import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { LotBinSchema } from "./lots";

export const getLotDetail = {
  name: "getLotDetail" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    limit: z.number().int().min(1).max(500).default(50),
    offset: z.number().int().min(0).default(0),
  }),
  output: z.object({
    lot: z
      .object({
        inventoryItemId: inventoryItemIdFormat.schema,
        lotNumber: z.string().nullable(),
        expirationDate: z.date().nullable(),
        productId: productIdFormat.schema.nullable(),
        productTitle: z.string().nullable(),
        productSku: z.string().nullable(),
        productImage: z.string().nullable(),
        onHandQuantity: z.number(),
        bins: z.array(LotBinSchema),
      })
      .nullable(),
    shipments: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        orderName: z.string().nullable(),
        externalOrderId: z.string().nullable(),
        redoOrderId: z.string().nullable(),
        customerName: z.string().nullable(),
        customerEmail: z.string().nullable(),
        quantity: z.number(),
        fulfilledAt: z.date(),
        warehouseName: z.string().nullable(),
        shippingCity: z.string().nullable(),
        shippingProvince: z.string().nullable(),
        shippingCountry: z.string().nullable(),
        trackingNumber: z.string().nullable(),
      }),
    ),
    totalShipmentCount: z.number(),
  }),
};

export type GetLotDetailInput = z.infer<typeof getLotDetail.input>;
export type GetLotDetailOutput = z.infer<typeof getLotDetail.output>;
